module.exports = __webpack_public_path__ + "static/img/new-Logo-color.57d03cf.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/new-Logo-color.png
// module id = pyqL
// module chunks = 1